module.exports = __webpack_public_path__ + "img/Logo_1000x1000.6b21b471.jpg";